module.exports = __webpack_public_path__ + "media/images/avatar-910ad4dcd615c97fa8cd8f2e4791e2ad.png";